import type { DocCategory } from '../registry';
import Faq, { toc as faqToc } from '../pages/faq/index';

export const faq: DocCategory = {
  id: 'faq',
  label: 'FAQ',
  pages: [
    {
      slug: 'faq',
      title: 'Frequently asked questions',
      eyebrow: 'FAQ',
      description: 'Verdict-first answers to the most common questions, each with a permalink.',
      toc: faqToc,
      Body: Faq,
      related: [
        { label: 'Licensing & activation', to: '/docs/concepts/licensing' },
        { label: 'Local & private', to: '/docs/concepts/local-and-private' },
        { label: 'System requirements', to: '/docs/reference/system-requirements' },
      ],
    },
  ],
};
